/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Camera: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <g clipPath='url(#clip0_20400_961)'>
      <path
        d='M21 4H17L15 1H9L7 4H3C2.20435 4 1.44129 4.31607 0.87868 4.87868C0.31607 5.44129 0 6.20435 0 7L0 19C0 19.7956 0.31607 20.5587 0.87868 21.1213C1.44129 21.6839 2.20435 22 3 22H21C21.7956 22 22.5587 21.6839 23.1213 21.1213C23.6839 20.5587 24 19.7956 24 19V7C24 6.20435 23.6839 5.44129 23.1213 4.87868C22.5587 4.31607 21.7956 4 21 4ZM12 18C11.0111 18 10.0444 17.7068 9.22215 17.1573C8.3999 16.6079 7.75904 15.827 7.3806 14.9134C7.00216 13.9998 6.90315 12.9945 7.09607 12.0245C7.289 11.0546 7.7652 10.1637 8.46447 9.46447C9.16373 8.7652 10.0546 8.289 11.0245 8.09607C11.9945 7.90315 12.9998 8.00216 13.9134 8.3806C14.827 8.75904 15.6079 9.3999 16.1573 10.2221C16.7068 11.0444 17 12.0111 17 13C17 14.3261 16.4732 15.5979 15.5355 16.5355C14.5979 17.4732 13.3261 18 12 18Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_20400_961'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </React.Fragment>
)
